<template>
  <v-dialog v-model="dialogVisible"
    persistent
    max-width="300px" 
  >
    <template #activator="{ on, attrs }">
      <v-btn class="ml-3" color="primary" v-on="on" :attrs="attrs" :disabled="disabled">Continue</v-btn>
    </template>

    <v-card>
      <v-card-title style="background-color: #004056" class="white--text">
        Confirm your Reward
      </v-card-title>

      <v-divider />

      <v-card-text class="mt-3">
        <div>
          <slot />
        </div>

        <div class="mt-4">
          This amount will be deducted from my reward balance, and a 
          redemption code will be issued.
        </div>
      </v-card-text>

      <v-divider/>

      <v-card-actions class="justify-center py-4">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="confirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'RewardConfirmDialog',

    props: { 
      disabled: { type: Boolean, default: false },
    },

    data: () => ({
      dialogVisible: false,
    }),

    methods: {
      close() {
        this.dialogVisible = false
      },

      confirm() {
        this.close()
        this.$emit('confirm')
      },
    },
  }
</script>
